import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../services/api';
import { saveAuth } from '../services/auth';
import './Auth.css';

export default function Cadastro() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const convidadoPorId = searchParams.get('ref');
  const [form, setForm] = useState({ nome: '', email: '', senha: '', confirmar: '', whatsapp: '', cidade_id: '' });
  const [cidades, setCidades] = useState([]);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [sucessoCupom, setSucessoCupom] = useState(null);
  const [loading, setLoading] = useState(false);

  const [cupomCodigo, setCupomCodigo] = useState('');
  const [cupomValidado, setCupomValidado] = useState(null);
  const [cupomErro, setCupomErro] = useState('');
  const [validandoCupom, setValidandoCupom] = useState(false);

  useEffect(() => {
    api.get('/cidades/publicas').then(data => setCidades(data)).catch(() => {});
  }, []);

  function set(field) {
    return e => setForm(f => ({ ...f, [field]: e.target.value }));
  }

  async function validarCupom() {
    if (!cupomCodigo.trim()) return;
    setCupomErro('');
    setCupomValidado(null);
    setValidandoCupom(true);
    try {
      const data = await api.get(`/cupons/validar/${encodeURIComponent(cupomCodigo.trim())}`);
      setCupomValidado(data);
    } catch (err) {
      setCupomErro(err.message);
    } finally {
      setValidandoCupom(false);
    }
  }

  function limparCupom() {
    setCupomCodigo('');
    setCupomValidado(null);
    setCupomErro('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');
    if (form.senha !== form.confirmar) return setErro('As senhas não conferem.');
    if (form.senha.length < 6) return setErro('A senha deve ter pelo menos 6 caracteres.');
    if (cupomCodigo.trim() && !cupomValidado) {
      return setErro('Você adicionou um cupom, mas ainda não realizou a validação. Valide o cupom antes de concluir seu cadastro.');
    }
    setLoading(true);
    try {
      const data = await api.post('/auth/register', {
        nome: form.nome,
        email: form.email,
        senha: form.senha,
        whatsapp: form.whatsapp,
        cidade_id: form.cidade_id,
        convidado_por_id: convidadoPorId || undefined,
        cupom_codigo: cupomValidado ? cupomValidado.codigo : undefined,
      });
      saveAuth(data.token, data.user);
      setSucesso(true);
      setSucessoCupom(data.cupom_aplicado || null);
      setTimeout(() => navigate('/'), data.cupom_aplicado ? 2500 : 1500);
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">⚽</div>
        <h1 className="auth-title">Criar Conta</h1>
        <p className="auth-sub">Junte-se ao Palpitar!</p>
        {sucesso && (
          <div className="alert alert-success">
            {sucessoCupom
              ? <>🎉 Cadastro realizado e cupom aplicado! Você recebeu ⭐ +{sucessoCupom.pontos_bonus} pontos e 👑 {sucessoCupom.dias_premium} dias Premium.</>
              : 'Cadastro realizado com sucesso!'}
          </div>
        )}
        {erro && <div className="alert alert-error">{erro}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome completo</label>
            <input value={form.nome} onChange={set('nome')} required placeholder="Seu nome" />
          </div>
          <div className="form-group">
            <label>E-mail</label>
            <input type="email" value={form.email} onChange={set('email')} required placeholder="seu@email.com" />
          </div>
          <div className="form-group">
            <label>WhatsApp</label>
            <input type="tel" value={form.whatsapp} onChange={set('whatsapp')} required placeholder="(00) 90000-0000" />
          </div>
          <div className="form-group">
            <label>Cidade</label>
            <select value={form.cidade_id} onChange={set('cidade_id')} required>
              <option value="">Selecione sua cidade</option>
              {cidades.map(c => (
                <option key={c.id} value={c.id}>{c.nome} - {c.estado}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Senha</label>
            <input type="password" value={form.senha} onChange={set('senha')} required placeholder="••••••••" />
          </div>
          <div className="form-group">
            <label>Confirmar Senha</label>
            <input type="password" value={form.confirmar} onChange={set('confirmar')} required placeholder="••••••••" />
          </div>

          <div className="cupom-box">
            <label>🎁 Possui um cupom?</label>
            {cupomValidado ? (
              <div className="alert alert-success" style={{ marginBottom: 0 }}>
                🎉 Cupom <b>{cupomValidado.codigo}</b> aplicado com sucesso!<br />
                Você vai receber: ⭐ +{cupomValidado.pontos_bonus} pontos · 👑 {cupomValidado.dias_premium} dias Premium
                <button type="button" className="btn-link" style={{ display: 'block', marginTop: 6, padding: 0 }} onClick={limparCupom}>
                  Remover cupom
                </button>
              </div>
            ) : (
              <>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    value={cupomCodigo}
                    onChange={e => setCupomCodigo(e.target.value.toUpperCase())}
                    placeholder="Digite seu cupom e ganhe benefícios exclusivos"
                    style={{ flex: 1 }}
                  />
                  <button type="button" className="btn btn-secondary" onClick={validarCupom} disabled={validandoCupom || !cupomCodigo.trim()}>
                    {validandoCupom ? 'Validando...' : 'Validar'}
                  </button>
                </div>
                {cupomErro && <span className="form-hint" style={{ color: 'var(--danger)' }}>{cupomErro}</span>}
              </>
            )}
          </div>

          <button type="submit" className="btn btn-primary btn-block" disabled={loading} style={{ marginTop: 16 }}>
            {loading ? 'Criando conta...' : 'Criar Conta'}
          </button>
        </form>
        <p className="auth-footer">Já tem conta? <Link to="/login">Entrar</Link></p>
      </div>
    </div>
  );
}
